export default {
  getLots: state => state.lots,
  getBuyRequests: state => state.buy_requests
}
